import React, { useCallback } from 'react';
import { IconType } from '../../misc/Icon/Icon';
import { StrictReactNode } from '../../types/StrictReactNode';
import { prepareProps } from '../../utils/propUtils';
import { BaseDialog, BaseDialogProps } from '../BaseDialog/BaseDialog';
import { BaseDialogIconButton } from '../BaseDialogIconButton/BaseDialogIconButton';
import styles from './EditDialog.module.css';

export type EditDialogProps<TAnyTabName extends string> = Omit<
  BaseDialogProps<TAnyTabName>,
  'renderButtons'
> & {
  opened: boolean;
  onAccept: () => void;
};

export const EditDialog = React.memo(
  <TAnyTabName extends string>(props: EditDialogProps<TAnyTabName>) => {
    const { onAccept, children, ...remainingProps } = prepareProps({ props });

    const renderButtons = useCallback((): Array<StrictReactNode> => {
      return [
        <BaseDialogIconButton
          key="accept"
          iconName="check"
          iconType={IconType.Regular}
          className={styles.acceptButton}
          onClick={onAccept}
          data-testid="EditDialog.AcceptButton"
        ></BaseDialogIconButton>
      ];
    }, [onAccept]);

    return (
      <BaseDialog
        {...remainingProps}
        renderButtons={renderButtons}
      >
        {children}
      </BaseDialog>
    );
  }
) as <TAnyTabName extends string>(
  props: EditDialogProps<TAnyTabName>
) => JSX.Element;
